import * as React from 'react'
import { FormErrorsType } from '../../../hooks'
import { Alert } from '../Alert/Alert'

type FormErrorsProps = {
    errors?: FormErrorsType
}

export const FormErrors: React.FC<FormErrorsProps> = ({ errors }) => {
    if (!errors) {
        return null
    }

    return Object.keys(errors).map((key) => {
        const error = errors[key]
        return <Alert key={key} variant="error" description={error} />
    })
}
